import { useUserStore } from '../stores/user';
import { useAlerts } from '../stores/alerts';
import { useSessionWarning } from '../stores/sessionWarning';
import i18n from '../I18n';

let sessionTimeout: ReturnType<typeof setTimeout> | null = null;
let warningTimeout: ReturnType<typeof setTimeout> | null = null;

// Cuánto antes de que expire la sesión se le avisa al alumno (15 min). Cuando
// falta esto, se muestra el banner con el botón "Renovar sesión".
export const SESSION_WARNING_BEFORE_MS = 15 * 60 * 1000;

// CWE-922: el `exp` (epoch en segundos) llega del backend en signin/me/renew. Ya
// NO se decodifica el JWT en JS — el token vive en la cookie HttpOnly, invisible acá.
export function startSessionTimer(exp: number) {
	clearSessionTimer();
	if (!exp) return;

	const timeUntilExpiry = exp * 1000 - Date.now();
	if (timeUntilExpiry <= 0) {
		expireSession();
		return;
	}

	// Aviso "tu sesión está por expirar": 15 min antes, o de inmediato si al
	// (re)armar el timer ya estamos dentro de esa ventana. Al renovar, el nuevo
	// exp es lejano → timeUntilWarning > 0 y el banner no se muestra.
	const timeUntilWarning = timeUntilExpiry - SESSION_WARNING_BEFORE_MS;
	if (timeUntilWarning <= 0) {
		useSessionWarning.getState().show(exp);
	} else {
		warningTimeout = setTimeout(() => {
			useSessionWarning.getState().show(exp);
		}, timeUntilWarning);
	}

	sessionTimeout = setTimeout(() => {
		expireSession();
	}, timeUntilExpiry);
}

export function clearSessionTimer() {
	if (sessionTimeout) {
		clearTimeout(sessionTimeout);
		sessionTimeout = null;
	}
	if (warningTimeout) {
		clearTimeout(warningTimeout);
		warningTimeout = null;
	}
	useSessionWarning.getState().hide();
}

function expireSession() {
	const { userLogout } = useUserStore.getState();
	const { addAlert } = useAlerts.getState();

	useSessionWarning.getState().hide();
	userLogout();
	addAlert({
		message: i18n.t('Current session is expired', { ns: 'Common' }),
	});
}
